import { render, staticRenderFns } from "./SalesmanAssignment.vue?vue&type=template&id=03cf0e95&"
import script from "./SalesmanAssignment.vue?vue&type=script&lang=js&"
export * from "./SalesmanAssignment.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanAssignment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports